var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 9.28516V2.5C15.375 1.26953 14.3555 0.25 13.125 0.25H3C1.73438 0.25 0.75 1.26953 0.75 2.5V9.28516C0.75 10.5156 1.73438 11.5 3 11.5L4.125 11.5352V13.4336C4.125 13.7148 4.44141 13.8555 4.65234 13.7148L7.57031 11.5352L13.125 11.5C14.3555 11.5 15.375 10.5156 15.375 9.28516ZM21 4.75H16.5V9.25C16.5 11.1133 14.9531 12.625 13.125 12.625H9.75V13.75C9.75 15.0156 10.7344 16 12 16H16.3945L19.3125 18.2148C19.5234 18.3555 19.875 18.2148 19.875 17.9336V16H21C22.2305 16 23.25 15.0156 23.25 13.75V7C23.25 5.76953 22.2305 4.75 21 4.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.529b8b58436e4937e3942f1379602ac9.svg";
export { ForwardRef as ReactComponent };